module.exports = __webpack_public_path__ + "img/sv75.e47bf5ec.svg";